import React, { cloneElement, useEffect, useState } from "react";
import {
  Button,
  Datagrid,
  Filter,
  FunctionField,
  Labeled,
  List,
  ReferenceField,
  ResourceContextProvider,
  sanitizeListRestProps,
  SearchInput,
  ShowProps,
  TextField,
  TopToolbar,
  useDataProvider,
  useListContext,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import IconPlus from "@material-ui/icons/Add";
import DeleteNotTakingReportButton from "./components/DeleteNotTakingReportButton";
import BusDataField from "./components/BusDataField";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button
        onClick={() =>
          history.push(
            `/notTakingReports/create?source=${JSON.stringify({
              studentId: Number(props.filterValues?.StudentId),
            })}&studentId=${Number(props.filterValues?.StudentId)}`
          )
        }
        label="Create Not Taking Report"
      >
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const Route = (props: ShowProps) => {
  const [routeData, setRouteData] = useState<IRouteData[]>([]);
  const provider = useDataProvider();

  useEffect(() => {
    provider
      .customGetOne(`students/${props.id}/routeNames`)
      .then(({ data }: any) => {
        setRouteData(data as IRouteData[]);
      });
  }, []);

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Route Detail</Typography>
        </Grid>

        <Grid item xs={4}>
          <Labeled source="Am Bus">
            <BusDataField type="to_school" data={routeData} label="AM Bus" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <Labeled source="Pm Bus">
            <BusDataField type="from_school" data={routeData} label="PM Bus" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={4}>
          <Labeled source="Cca Bus">
            <BusDataField type="cca_school" data={routeData} label="CCA Bus" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Not Taking Reports</Typography>
        </Grid>

        <Grid item xs={12}>
          <ResourceContextProvider value="notTakingReports">
            <List
              {...props}
              exporter={false}
              hasCreate={false}
              filters={<ThisFilter />}
              filterDefaultValues={{
                StudentId: Number(props.id),
              }}
              sort={{ field: "date", order: "DESC" }}
              bulkActionButtons={false}
              title=" "
              actions={<ListActions history={props.history} />}
            >
              <Datagrid>
                <TextField source="id" emptyText="-" />
                <ReferenceField
                  source="busSchedulePlanId"
                  label="Wave Name"
                  reference="busSchedulePlans"
                  link={false}
                >
                  <ReferenceField
                    source="busScheduleId"
                    reference="busSchedules"
                    link={false}
                  >
                    <TextField source="name" />
                  </ReferenceField>
                </ReferenceField>
                <CustomDateField source="date" />
                <FunctionField
                  label="Action"
                  render={(record: any) => (
                    <DeleteNotTakingReportButton
                      notTakingReportId={record.id}
                    />
                  )}
                />
              </Datagrid>
            </List>
          </ResourceContextProvider>
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Route;
